module.exports = __webpack_public_path__ + "static/media/logo-gergo.09ff83cb.png";